module.exports = "<div id=\"pr-write\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/order/product/review.html
// module id = 197
// module chunks = 0